"use client";

import React from "react";
import type { ComposeProviderStackProps } from "@/lib/core/crm/types";
import { ComposeFormStateProvider } from "./ComposeFormStateContext";
import { ComposeRecipientsProvider } from "./ComposeRecipientsContext";
import { ComposeClientProvider } from "./ComposeClientContext";
import { ComposeEmailFormatProvider } from "./ComposeEmailFormatContext";

export function ComposeProviderStack({
  children,
  formState,
  recipientsState,
  clientState,
  emailFormatState,
}: ComposeProviderStackProps) {
  return (
    <ComposeFormStateProvider value={formState}>
      <ComposeRecipientsProvider value={recipientsState}>
        <ComposeClientProvider value={clientState}>
          <ComposeEmailFormatProvider value={emailFormatState}>
            {children}
          </ComposeEmailFormatProvider>
        </ComposeClientProvider>
      </ComposeRecipientsProvider>
    </ComposeFormStateProvider>
  );
}
